import React, { useState, useEffect } from 'react';
import './PureHtmlEditor.css';

const PureHtmlEditor = ({ initialContent = '', onChange, placeholder = 'HTML 소스 코드를 입력하세요...' }) => {
  const [content, setContent] = useState(initialContent);

  // 초기 콘텐츠 설정
  useEffect(() => {
    setContent(initialContent);
  }, [initialContent]);

  // 소스 코드 변경 핸들러
  const handleChange = (e) => {
    const value = e.target.value;
    setContent(value);
    if (onChange) {
      onChange(value);
    }
  };

  // 코드 포맷팅 (들여쓰기)
  const formatHtml = () => {
    try {
      // 간단한 HTML 포맷팅
      let formatted = content;
      
      // 태그별로 줄바꿈 추가
      formatted = formatted.replace(/></g, '>\n<');
      
      // style 태그 내용 포맷팅
      formatted = formatted.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, p1) => {
        const styleContent = p1.trim()
          .replace(/}/g, '}\n')
          .replace(/{/g, ' {\n  ')
          .replace(/;/g, ';\n  ')
          .replace(/\n\s*\n/g, '\n');
        return `<style>\n${styleContent}\n</style>`;
      });
      
      setContent(formatted);
      if (onChange) {
        onChange(formatted);
      }
    } catch (error) {
      console.error('HTML 포맷팅 오류:', error);
    }
  };

  return (
    <div className="pure-html-editor">
      <div className="pure-html-editor-toolbar">
        <span className="toolbar-info">
          Pure HTML 소스 편집기
        </span>
        <button 
          className="format-btn"
          onClick={formatHtml}
          title="HTML 포맷팅"
        >
          {'{/}'} 포맷
        </button>
      </div>
      
      <textarea
        className="pure-html-source"
        value={content}
        onChange={handleChange}
        placeholder={placeholder}
        spellCheck={false}
      />
      
      <div className="pure-html-editor-footer">
        <span className="char-count">
          {content.length} 문자
        </span>
        {content.includes('<style>') && (
          <span className="css-indicator">
            CSS 포함됨
          </span>
        )}
      </div>
    </div>
  );
};

export default PureHtmlEditor;